import React, { Fragment, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useAxios } from '../../../../hooks/useAxios';

import Modal from 'react-bootstrap/Modal';
import Generated  from '../../../../components/system/Generated';
import DeleteBtn from '../../../../components/buttons/DeleteBtn';
// import EmailError from '../system/EmailError';
import CopyToPhase from './CopyToPhase';

// lklklk future:
// ability to let them decide if they want to switch status to "Moved to Phase"?

import dayjs from 'dayjs'

import { formObj } from '../../../../utils/schemas';
import { emptyObj } from '../../../../utils/functions';

const View = (props) => {
  const debug = true;
  const { userDetails, schema, obj, selected, selectedIds, phase, phases, plots, setPlots, deletePlots, handleClose, toParent } = props;
  const formText = { submit: `Update ${selected.length} Plots`, pending: 'Updating', success: 'Updated!', cancel: 'Cancel' };
  const errorCode = '5514'

  const { serverCall, pending, error } = useAxios();
  const { control, register, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm({
    defaultValues: useMemo(() => formObj(schema), [schema])
  });

  useEffect(() => {
    if(!obj) return;
    let filled = formObj(schema, obj);
    reset(filled);
  }, [schema, obj, reset])

  useEffect(() => {
    if(selected.length < 2) handleClose();
  }, [selected, handleClose])

  const onSubmit = async (data) => {
    if(debug) console.log(data);
    // create the update object, only with non-null values
    // this could mean they could do a space and it would clear values
    let update = {};
    for (const [key, value] of Object.entries(data)) {
      if(value===null) continue;
      update[key] = value;
    }

    console.log(selected);

    // let styleUpdates = [];

    // setTypes((prev) => {
    //   let arr = [...prev];
    //   for(const id of selected) {
    //     let idx = arr.findIndex(x => x.id === id);
    //     // if we aren't updating styles, clobber existing values
    //     if(emptyObj(update.styling)) {
    //       arr[idx] = {...arr[idx], ...update}
    //     } else {
    //       let styling = {...arr[idx].styling, ...update.styling};
    //       styleUpdates.push({ id: arr[idx].id, styling })
    //       arr[idx] = {...arr[idx], ...update}
    //       arr[idx].styling = styling;
    //     }
    //   }
    //   return arr;
    // })

    // update.ids = selected;
    // update.styleUpdates = styleUpdates;
    // update.updatedAt = dayjs().format('YYYY-MM-DD HH:mm:ss');
    // update.updatedBy = userDetails.id;

    // let res = await serverCall({ method: 'PATCH', data: update, url: `/library/types/bulk`, eamsAuth0: true });
    // if(res.status!==200) return alert('Error updating types. Contact support.') // lklklk
    // handleClose();
  };

  const fromChild = async (data) => {
    const { type, value } = data;
    // console.log(data);
    if(type==='copied to phase') {
      if(emptyObj(value)) return;

      await setPlots((prev) => {
        let arr = [...prev];
        // update the status for these
        for(const id of selectedIds) {
          let idx = arr.findIndex(x => x.id === id);
          arr[idx].publicStatus = 'Moved to Another Phase';
        }

        // then merge the new ones in
        arr = [...arr, ...value.new];

        // and update the... updated ones
        for(const plot of value.updated) {
          let idx = arr.findIndex(x => x.id === plot.id);
          if(idx > -1) arr[idx] = {...arr[idx], ...plot};
        }
        return arr;
      })
    } else if(type==='delete confirmed') {
      if(toParent) deletePlots();
    }
  }

  return (
    <Fragment>
      <Modal.Header closeButton>
        <Modal.Title>Edit {selectedIds.length} Plots</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { phases.length < 2 && <p>Coming soon.</p>}
        {/* <form onSubmit={handleSubmit(onSubmit)} autoComplete="off" className="mb-3">
          <Generated id="bulk-edit-plots" schema={schema} size="md" pieces={{ register, control, setValue, watch, errors, toParent: fromChild }} />
        </form> */}

        <CopyToPhase key={JSON.stringify(selectedIds)+phase.id} hideToggle={true} phase={phase} phases={phases} plots={plots} appIdStr={JSON.stringify(selected)} toParent={fromChild} />

      </Modal.Body>
      {/* <Modal.Footer>
        <DeleteBtn toParent={fromChild} text={`Delete ${selected.length} Plots`} />

        <button className="btn btn-sm btn-outline-dark ms-auto me-1" type="button" onClick={handleClose}>
          {formText.cancel}
        </button>

        <button className={`btn btn-sm ${error ? 'btn-danger' : 'btn-success'}`} type="submit" disabled={pending} onClick={() => handleSubmit(onSubmit)() }>
          { !pending && !error && (formText.submit)}
          { pending === true && (
            <Fragment>
              <div className="spinner-border spinner-border-sm text-white me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              {formText.pending}
            </Fragment>
          )}
          { error && (`Error saving (${errorCode})`)}
          { pending ==='success' && formText.success}
        </button>
      </Modal.Footer> */}
    </Fragment>
  )
}

export default View;
